import { useRouter } from "next/navigation";
import { FC, useCallback } from "react";
import styled, { css } from "styled-components";
import { CloseIcon } from "../icons/CloseIcon";
import useCart from "../store/useCart";
import { defaultThemeInRgb } from "../styles/defaultTheme";
import {
  FlexCoulmn,
  FlexRow,
  StyledImage,
  StyledTitle
} from "../styles/globalsStyles";
import { Routes } from "../utils/clientRoutes";
import Drawer, { Side } from "./Drawer";
import TitleWithBorder from "./TitleWithBorder";
import { Button } from "./core/Button";

const CartDrawer: FC<{
  toShow: boolean;
  setToShow: (x: boolean) => void;
  side: Side;
}> = ({ setToShow, toShow, side }) => {
  const { cart, removeItemFromCart } = useCart();
  const router = useRouter();
  const handleGoToBuyPage = useCallback(async () => {
    setToShow(false);
    router.push(Routes.cartStorePopupBuyPage);
  }, [router, setToShow]);

  if (!toShow) return null;
  return (
    <Drawer
      onCloseThisDrawer={() => setToShow(false)}
      side={side}
      useDrawer={true}
      hideArrow
      forceOpen={toShow}
      drawerId="cartDrawer"
      height={"-webkit-fit-content"}
      extraStyles={
        side !== "top"
          ? css`
              bottom: 0;
              position: fixed;
            `
          : undefined
      }
    >
      <CartWrap>
        <FlexRow
          $justifyContent="center"
          $alignItems="center"
          $width={"100%"}
          style={{ backgroundColor: "lightgray" }}
        >
          <TitleWithBorder text={"העגלה שלי"} />
        </FlexRow>
        <FlexCoulmn $justifyContent="start" $gap={"1rem"} $padding={".5rem"}>
          {!cart || !cart.items || cart?.items.length === 0 ? (
            <StyledTitle>כרגע אין לך פריטים בעגלה</StyledTitle>
          ) : (
            <>
              <FlexCoulmn $maxHeight={"500px"} $overflow="auto">
                {cart?.items.map((item) => (
                  <FlexRow
                    key={item.id}
                    $gap={".5rem"}
                    // $justifyContent="center"
                    $alignItems="center"
                  >
                    <StyledImage src={item.imgs[0]} width={100} />
                    <ItemName>{item.name}</ItemName>
                    <ItemPrice>{item.price}₪</ItemPrice>
                    <CloseIcon
                      onClick={() => removeItemFromCart({ itemId: item.id })}
                    />
                  </FlexRow>
                ))}
              </FlexCoulmn>
              <Button onClick={handleGoToBuyPage}>לרכישת הפריטים</Button>
            </>
          )}
        </FlexCoulmn>
      </CartWrap>
    </Drawer>
  );
};

const { b, g, r } = defaultThemeInRgb.tertiaryColor;
const CartWrap = styled(FlexCoulmn)`
  background-color: rgba(${r}, ${g}, ${b}, 0.9);
  gap: 0.5rem;
`;

const ItemName = styled.h3``;
const ItemPrice = styled.h4``;
export default CartDrawer;
